import { QueryBuilder } from './query-builder.class';
import { from, Observable } from 'rxjs';
import { JsonSerializer } from './serializer.class';
import { Area as AreaModel } from '../../areas/models/area.model';
import { Area } from '../entities/area.entity';
import { ComponentModel } from '../../components/models/component.model';

/**
 * Area Entity Query Builder.
 */
export class AreaQueryBuilder extends QueryBuilder {
  constructor(migrate = false) {
    super(new Area(), migrate);
  }

  findWithIncludes(id: number, includes: string[] = []): Observable<any> {
    return from(
      new Promise(async (resolve, reject) => {
        const data: AreaModel = await this.find(this._table, id);

        if (includes.includes('components')) {
          const components: ComponentModel[] = await this.loadItemRelationship('components', 'area_id', data.id);

          if (components) {
            data.components = {
              data: components,
            };
          }
        }

        resolve(JsonSerializer.item(data));
      })
    );
  }

  delete(area: AreaModel) {
    const query = `DELETE FROM ${this._table} ${this._buildWhereQuery()}`;

    return from(
      new Promise((resolve, reject) => {
        this._query(query, []).then(
          (response: any) => {
            resolve(response);
          },
          error => {
            reject(error);
          }
        );
      })
    );
  }
}
